<template>
    <v-dialog v-model="dialog" width="auto" :min-width="minWidth" :theme="theme" :persistent="payload.persistent"
        @keydown="handleKeydown">
        <v-card v-resize="onResize">
            <v-card-title>{{ payload.title }}</v-card-title>
            <v-card-text>
                <component ref="component" :is="component" :payload="payload" />
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="cancel != ''" variant="text" color="on-surface" @click="rejected">{{ cancel }}</v-btn>
                <v-btn :color="payload.destructive ? 'error' : 'primary'" variant="text" @click="accepted">
                    {{ ok }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { get_theme } from '../routes';

export default {
    name: 'TemplateDialog',
    props: {
        release: Function,
        reject: Function,
        dispose: Function,
        component: Object,
        payload: Object,
    },
    data() {
        return {
            accept: false,
            dialog: true,
            minWidth: 400,
        };
    },
    methods: {
        accepted() {
            const finallize = this.$refs.component.finallize;
            if (finallize != null) {
                const accepted = finallize();
                if (accepted.then != null) {
                    accepted.then(() => {
                        this.accept = true;
                        this.close();
                    });
                    return;
                } if (!accepted) {
                    return;
                }
            }
            this.accept = true;
            this.close();
        },
        rejected() {
            this.close();
        },
        close() {
            this.dialog = false;
        },
        handleKeydown(e) {
            const code = e.keyCode;
            if (code === 13) {
                this.accepted();
                e.preventDefault();
                return false;
            } if (code === 27) {
                this.rejected();
                e.preventDefault();
                return false;
            }
            return true;
        },
        onResize() {
            this.minWidth = Math.min(400, window.innerWidth - 20);
        },
    },
    computed: {
        ok() {
            return this.payload.ok || this.$tr('Готово');
        },
        cancel() {
            if (this.payload.cancel == null) {
                return this.$tr('Отмена');
            }
            return this.payload.cancel;
        },
        theme() {
            return get_theme();
        },
        finished() {
            return this.payload.finished;
        },
    },
    mounted() {
        this.$nextTick(() => {
            const component = this.$refs.component;
            if (component != null) {
                const initialize = component.initialize;
                if (initialize != null) {
                    initialize();
                }
            }
            this.dialog = true;
        });
    },
    watch: {
        finished(value) {
            if (value) {
                this.accepted();
            }
        },
        dialog(value) {
            if (!value) {
                const accept = this.accept;
                const dispose = this.dispose;
                if (dispose != null) {
                    dispose();
                }
                const payload = this.payload;
                if (accept) {
                    const release = this.release;
                    if (release != null) {
                        release(payload);
                    }
                } else {
                    const reject = this.reject;
                    if (reject != null) {
                        reject(payload);
                    }
                }
            }
        },
    },
};
</script>

<style scoped></style>
